export const DETAIL_CACHE_MAX_ENTRIES = 10;

/**
 * Route params are strings while API ids may be numbers; normalize so cache
 * keys and "active id" comparisons always match.
 */
export const normalizeCacheId = (id) =>
    id === null || id === undefined ? null : String(id);

/**
 * Writes an entry into a detail cache map (mutating, for use inside
 * Immer-powered reducers) and evicts the oldest entries beyond the cap.
 */
export const writeDetailCache = (
    cache,
    id,
    data,
    maxEntries = DETAIL_CACHE_MAX_ENTRIES,
) => {
    const key = normalizeCacheId(id);
    if (key === null) {
        return;
    }

    cache[key] = { data, fetchedAt: Date.now() };

    const keys = Object.keys(cache);
    if (keys.length <= maxEntries) {
        return;
    }

    keys.sort((a, b) => (cache[a]?.fetchedAt ?? 0) - (cache[b]?.fetchedAt ?? 0))
        .slice(0, keys.length - maxEntries)
        .forEach((staleKey) => {
            delete cache[staleKey];
        });
};

export const readDetailCache = (cache, id) => {
    const key = normalizeCacheId(id);
    return key === null ? undefined : cache?.[key];
};
